import React, { useState, useEffect } from 'react';
import AdminWrapper from "./AdminWrapper";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar";
import { StylesStatistics } from "../Statistics/styled";
import Chart from 'react-apexcharts';
import { API } from '../../API';
import moment from 'moment';
import Modal from "../../Components/Modal/Modal"
import DatePicker from "react-datepicker"

const EventCalendar = () => {
  const [eventData, setEventData] = useState([]);
  const [modal,setmodal] = useState(false)
  const [desmodal,setdesmodal] = useState(false)
  const [institute,setinstitute] = useState([])
  const [form, setForm] = useState({
    instituteName: '',
    color: '#000000',
    title: '',
    start: '',
    end: '',
    description: ''
  });

  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false)
  const [selectedEventDescription, setSelectedEventDescription] = useState({});
  const [error, setError] = useState('');

  useEffect(() => {
    getEvents();
  }, []);

  const getEvents = async () => {
    try {
      const response = await API.eventsCalendar();
      const events = response.data.data.events;
      
      setEventData(events);
      setinstitute(response.data.data.insList);
        setIsLoaded(true)
    } catch (error) {
      console.error(error);
    }
  };

  const chartMake = (data) => {
    const length = data.length
    let series = []
    data.map(institute => 
        institute.events.map(event => (
            series.push({
          name: event.title,
          data: [{
            x: institute.name,
            y: [Date.parse(event.start), Date.parse(event.end)],
            description: event.description 
          }]
        })))
      );
    const chartData = {
      options: {
        chart: {
          type: 'rangeBar',
          height: length < 7 ? 350 : length * 50,
          toolbar: {
            show: true,
          },
          events: {
            click: function(event, chartContext, { dataPointIndex, seriesIndex }) {
            if(seriesIndex >= 0){
                const eventDescription = {
                    instituteName : series[seriesIndex].data[dataPointIndex].x,
                    title : series[seriesIndex].name,
                    start : moment(series[seriesIndex].data[dataPointIndex].y['0']).format('YYYY-MM-DD'),
                    end : moment(series[seriesIndex].data[dataPointIndex].y['1']).format('YYYY-MM-DD'),
                    description : series[seriesIndex].data[dataPointIndex].description,
                }
                setSelectedEventDescription(eventDescription);
                setdesmodal(true)
            }
            }
        },
        },
        annotations: {
            xaxis: [{
                x: new Date().getTime(),
                borderColor: '#FF4560',
                label: {
                    borderColor: '#FF4560',
                    style: {
                        color: '#fff',
                        background: '#FF4560',
                    },
                    text: 'Today',
                }
            }]
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          type: 'datetime',
        },
        fill: {
          type: 'solid',
          opacity: 0.6
        },
        legend: {
            position: 'top',
            show : false
        },
        dataLabels: {
            enabled: true,
            formatter: function(val) {
              var a = moment(val[0])
              var b = moment(val[1])
              var diff = b.diff(a, 'days')
              return diff + (diff > 1 ? ' days' : ' day')
            }
          },
      },
      series: series
    };

    return (
      <div className="event-calendar">
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="rangeBar"
          height={350}
        />
      </div>
    );
  };

  const isTitleDuplicate = (title, instituteName) => {
    const institute = eventData.find(inst => inst.name === instituteName);
    if (institute && institute.events.some(event => event.title.toLowerCase() === title.toLowerCase())) {
      return true;
    }
    return false;
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (name === 'title' || name === 'instituteName') {
        if (isTitleDuplicate(value, form.instituteName)) {
          setError('An event with this title already exists for the selected institute.');
        } else {
          setError('');  // Clear error if no duplicate
        }
      }
  };

  const handleSubmit = async(event) => {
    event.preventDefault();
    if (isTitleDuplicate(form.title, form.instituteName)) {
        setError('An event with this title already exists for the selected institute.');
        return; 
      }

    const request = await API.newEventsCalendar(form)
    setmodal(false)
    getEvents()
  };

  const deleteEvent = async(event) => {
    const request = await API.delEventsCalendar(event)
    setdesmodal(false)
    getEvents()
  }

  const renderForm = (institutes) => {
  
    const handleStartDateChange = date => {
      setSelectedStartDate(date);
      if (selectedEndDate && date > selectedEndDate) {
        setSelectedEndDate(null); // Clear end date if start date is later than end date
      }
      setForm(prev => ({ ...prev, ['start']: moment(date).format('YYYY-MM-DD') }));
    };
  
    const handleEndDateChange = date => {
      setSelectedEndDate(date);
      setForm(prev => ({ ...prev, ['end']: moment(date).format('YYYY-MM-DD') }));
    };
  
      return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="title">Event Title:</label>
        <input
          type="text"
          name="title"
          value={form.title}
          onChange={handleInputChange}
          placeholder="Enter event title"
          required
          style={{ width: '100%', padding: '8px' }}
        />
        {error && <div style={{ color: 'red', marginTop: '5px' }}>{error}</div>}
      </div>
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="instituteName">Institute Name:</label>
        <input
          type="text"
          name="instituteName"
          value={form.instituteName}
          onChange={handleInputChange}
          placeholder="Start typing institute name"
          required
          list="institute-list"
          style={{ width: '100%', padding: '8px' }}
        />
        <datalist id="institute-list">
        {
          institutes.map((inst, idx) => (
            <option key={idx} value={inst} />
          )
        )}
        </datalist>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="color">Choose Color:</label>
        <input
          type="color"
          id="color"
          name="color"
          value={form.color}
          onChange={handleInputChange}
          style={{ padding: '8px', width: '100px' }}  // Adjust size as needed
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div className="form-group">
          <label htmlFor="startDate">From:</label>
          <div className="input-icon">
            <DatePicker
              selected={selectedStartDate}
              onChange={handleStartDateChange}
              selectsStart
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              placeholderText="Start Date"
              dateFormat="dd-MM-yyyy"
              className="form-control"
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="endDate">To:</label>
          <div className="input-icon">
            <DatePicker
              selected={selectedEndDate}
              onChange={handleEndDateChange}
              selectsEnd
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              minDate={selectedStartDate}
              placeholderText="End Date"
              dateFormat="dd-MM-yyyy"
              className="form-control"
            />
          </div>
        </div>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <label htmlFor="description">Description:</label>
        <textarea
          id="description"
          name="description"
          value={form.description}
          onChange={handleInputChange}
          placeholder="Enter a detailed description"
          required
          style={{ width: '100%', height: '100px', padding: '8px' }}  // Adjust height as needed
        />
      </div>
      <button type="submit" style={{ padding: '10px 20px', background: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>
        Submit
      </button>
    </form>
  );
};
  

  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <StylesStatistics>
      <Modal
        header={'Add New Event'}
        onClose={() => setmodal(false)}
        show={modal}
      >
        {isLoaded ? renderForm(institute) : null}
      </Modal>
      {selectedEventDescription && (
            <Modal
            header={'Event Description:'}
            onClose={() => setdesmodal(false)}
            show={desmodal}
          >
            <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}>
            <h3>{selectedEventDescription.title}</h3>
            <p><strong>{selectedEventDescription.instituteName}</strong></p>
            <p>{moment(selectedEventDescription.start).format('DD MMM YYYY')} to {moment(selectedEventDescription.end).format('DD MMM YYYY')}</p>
            <p><strong>Description:</strong> {selectedEventDescription.description}</p>
            </div>
            <button 
                onClick={() => deleteEvent(selectedEventDescription)}
                style={{ marginTop: '10px', padding: '8px 16px', backgroundColor: '#FFA500', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
                Remove Event
            </button>
          </Modal>
            )
        }
      <button 
        type="button"
        className="btn btn-sm btn-primary"
        onClick={()=>{setmodal(true)}}>Add New Event</button>
        {chartMake(eventData)}
      </StylesStatistics>
    </AdminWrapper>
  );
};

export default EventCalendar;
